import dynamic from 'next/dynamic'

const TwoColumns = dynamic(() => import("@/components/content-types/two-columns"))
const Split = dynamic(() => import("@/components/content-types/split"))
const Flat = dynamic(() => import("@/components/content-types/flat"))
const Centered = dynamic(() => import("@/components/content-types/centered"))

export default function Content({ fields, ...rest }) {
  let type  = null;
  switch (fields.type) {
    case '2 Columns':
      type = <TwoColumns fields={fields} {...rest} />
      break;
    case 'Split':
      // @ts-ignore
      type = <Split fields={fields} {...rest} />
      break;
    case 'Flat':
      // @ts-ignore
      type = <Flat fields={fields} {...rest} />
      break;
    case 'Centered':
      // @ts-ignore
      type = <Centered fields={fields} {...rest} />
      break;
    default:
      type = null;
  }

  return type;
}
